import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { catalogCiiuClean, cleanSearchingCatalogCiiusPaginated } from "../../app/actions/catalogCiiuActions";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsCatalogCiius = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    if (icon === "new") {
      trackEvent({ component: "NewCatalogCiius", event: "NewCatalogCiius-Clicked" });
    } else if (icon === "list") {
      trackEvent({ component: "ListCatalogCiius", event: "ListCatalogCiius-Clicked" });
      dispatch(cleanSearchingCatalogCiiusPaginated());
    }

    dispatch(catalogCiiuClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCatalogCiius" && (
        <Link
          data-tip
          data-for="newCatalogCiiusTip"
          to="/admin-ciiu/new-ciiu"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCatalogCiius" && (
        <Link
          data-tip
          data-for="listCatalogCiiusTip"
          to="/admin-ciiu/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCatalogCiius" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCatalogCiiusTip"
            to="/admin-ciiu/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCatalogCiiusTip"
            to="/admin-ciiu/new-ciiu"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCatalogCiiusTip" place="left" effect="solid">
        {t("admin-ciiu.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCatalogCiiusTip" place="left" effect="solid">
        {t("admin-ciiu.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCatalogCiius;